import React, { useEffect, useRef, useState } from 'react'
import './DropdropFilterStyle.css'
import InputField from '../InputField/InputField'

const DropdropFilter = ({ options, onClick, Dropname, value }) => {
  const [isdropdown, setIsdropdown] = useState(false);

  const ref = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsdropdown(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  return (
    <div className="OptionmenuFilter" ref={ref}>
      <>
        <div className={`optionname active`} onClick={() => setIsdropdown(prev => !prev)}>
          <span>{value ? options?.filter(item => item?.value === value)[0]?.label : Dropname}</span>
          <img src="/assets/img/arrow-down.png" alt="" />
        </div>
        {isdropdown && <div className={`listoptionsdata active`}>
          {/* <InputField inputIcon={'search'} placeholder="Search here..." /> */}
          <div className="Datalistnamesfilter">
            <ul>
              {options?.map((item, index) => (
                <li onClick={() => { onClick(item?.value); setIsdropdown(false) }} key={index} value={item?.value}>
                  <span>{item?.label}</span>
                </li>
              ))}
            </ul>

          </div>
        </div>}
      </>
    </div>
  )
}

export default DropdropFilter